'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _RadioStyle = require('./RadioStyle.scss');

var _RadioStyle2 = _interopRequireDefault(_RadioStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Radio = (_dec = (0, _reactCssModules2.default)(_RadioStyle2.default), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Radio, _React$Component);

  function Radio() {
    (0, _classCallCheck3.default)(this, Radio);
    return (0, _possibleConstructorReturn3.default)(this, (Radio.__proto__ || (0, _getPrototypeOf2.default)(Radio)).apply(this, arguments));
  }

  (0, _createClass3.default)(Radio, [{
    key: 'render',
    value: function render() {
      var radioProps = (0, _assign2.default)({}, this.props);
      delete radioProps.styles;

      return _react2.default.createElement('input', (0, _extends3.default)({ type: 'radio', styleName: 'a-radio' }, radioProps));
    }
  }]);
  return Radio;
}(_react2.default.Component), _class2.propTypes = {
  name: _react.PropTypes.string.isRequired,
  id: _react.PropTypes.string.isRequired,
  value: _react.PropTypes.string.isRequired,
  defaultChecked: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = Radio;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/FormInput/Radio.js
// module id = 587
// module chunks = 0